export const MATTER_INSURANCE_COVERAGE_STATUS_OPTIONS = [
  "Unconfirmed",
  "Pending",
  "Confirmed",
  "Denied",
] as const;

export const MATTER_CONTACT_CONNECTION_FAULT_STATUS_OPTIONS = [
  "At Fault",
  "Not At Fault",
] as const;

export const MATTER_INSURANCE_COVERAGE_TYPE_OPTIONS = [
  "MedPay",
  "UM",
  "UIM",
] as const;

type NotApplicableInsuranceCoverage = "Not Applicable";

export const NOT_APPLICABLE_INSURANCE_COVERAGE: NotApplicableInsuranceCoverage =
  "Not Applicable";
